// CSRF token stored in memory only — never in a cookie or localStorage
// This prevents it from being visible in browser DevTools → Application → Cookies

import axiosInstance from './api/axios';

let _csrfToken = null;
let _fetchPromise = null;


class CSRFService {
  /**
   * Fetch a fresh token from the server and store it in memory.
   * Deduplicates concurrent calls so only one request fires at a time.
   */
  static async getToken() {
    if (_fetchPromise) return _fetchPromise;

    _fetchPromise = axiosInstance
      .get('/security/csrf-token')
      .then((response) => {
        _csrfToken = response.data.token;
        if (!_csrfToken) throw new Error('CSRF token missing in server response');
        return _csrfToken;
      })
      .finally(() => {
        _fetchPromise = null;
      });

    return _fetchPromise;
  }

  /**
   * Return the in-memory token, fetching it first if not yet obtained.
   */
  static async ensureToken() {
    if (_csrfToken) return _csrfToken;
    return this.getToken();
  }

  /**
   * Return the currently cached token synchronously (may be null on first load).
   */
  static getCachedToken() {
    return _csrfToken;
  }

  /**
   * Invalidate the cached token (call after a 403 CSRF error so next
   * request fetches a fresh one).
   */
  static clearToken() {
    _csrfToken = null;
  }
}

export default CSRFService;